export default __webpack_public_path__ + "022efb839d22fa54a7166b48eda57c5a.svg";